<template>
  <el-dialog
    title="新建采购订单"
    :visible.sync="dialogVisible"
    width="90%"
    :close-on-click-modal="false"
    :before-close="handleClose">
    <el-form ref="orderForm" :model="orderForm" :rules="rules" label-width="100px">
      <!-- 主订单信息 -->
      <el-card class="box-card">
        <div slot="header">
          <span>主订单信息</span>
        </div>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="订单名称" prop="OrderName">
              <el-input v-model="orderForm.OrderName" placeholder="请输入订单名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="采购计划" prop="PlanID">
              <el-select v-model="orderForm.PlanID" placeholder="请选择采购计划">
                <el-option
                  v-for="item in planOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>

      <!-- 子订单列表 -->
      <el-card class="box-card sub-order-card">
        <div slot="header" class="clearfix">
          <span>子订单信息</span>
          <el-button style="float: right" type="primary" size="small" @click="addSubOrder">
            添加子订单
          </el-button>
        </div>
        
        <el-table 
          :data="orderForm.subOrders" 
          border
          style="width: 100%"
          :header-cell-style="{ background: '#f5f7fa' }"
          highlight-current-row>
          <el-table-column label="供应商" width="200">
            <template slot-scope="scope">
              <el-select 
                v-model="scope.row.SupplierID" 
                placeholder="选择供应商"
                style="width: 100%">
                <el-option
                  v-for="item in supplierOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </template>
          </el-table-column>

          <el-table-column label="采购金额" width="150" align="right">
            <template slot-scope="scope">
              <span class="amount-text">¥ {{ scope.row.Money?.toFixed(2) || '0.00' }}</span>
            </template>
          </el-table-column>

          <el-table-column label="付款金额" width="150" align="right">
            <template slot-scope="scope">
              <span class="amount-text">¥ {{ scope.row.PayMoney?.toFixed(2) || '0.00' }}</span>
            </template>
          </el-table-column>

          <el-table-column label="物流单号" min-width="180">
            <template slot-scope="scope">
              <el-input 
                v-model="scope.row.LogisticsNo"
                placeholder="请输入物流单号"
                clearable>
              </el-input>
            </template>
          </el-table-column>

          <el-table-column label="物流方式" width="150">
            <template slot-scope="scope">
              <el-select 
                v-model="scope.row.Logistics" 
                placeholder="选择物流方式"
                style="width: 100%">
                <el-option label="快递" :value="1"></el-option>
                <el-option label="送货上门" :value="2"></el-option>
                <el-option label="上门取货" :value="3"></el-option>
              </el-select>
            </template>
          </el-table-column>

          <el-table-column label="付款状态" width="120" align="center">
            <template slot-scope="scope">
              <el-tag :type="getPaymentStatusType(scope.row)" size="medium">
                {{ getPaymentStatusText(scope.row) }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column label="操作" width="220" fixed="right">
            <template slot-scope="scope">
              <div class="operation-buttons">
                <el-button type="text" size="small" @click="editDetails(scope.$index)">
                  <i class="el-icon-edit"></i> 编辑明细
                </el-button>
                <el-divider direction="vertical"></el-divider>
                <el-button type="text" size="small" @click="handlePayment(scope.$index)">
                  <i class="el-icon-money"></i> 付款
                </el-button>
                <el-divider direction="vertical"></el-divider>
                <el-button type="text" size="small" class="delete-btn" @click="removeSubOrder(scope.$index)">
                  <i class="el-icon-delete"></i> 删除
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-card>

      <!-- 商品明细对话框 -->
      <el-dialog
        width="80%"
        title="编辑商品明细"
        :visible.sync="detailsDialogVisible"
        append-to-body>
        <el-table :data="currentDetails" border>
          <el-table-column label="商品名称">
            <template slot-scope="scope">
              <el-select v-model="scope.row.GoodId" placeholder="选择商品">
                <el-option
                  v-for="item in goodsOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="规格" prop="GoodSpecs"></el-table-column>
          <el-table-column label="数量">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.GoodNums" :min="1"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column label="单价">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.Price" :precision="2" :step="0.1"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column label="金额" prop="Money">
            <template slot-scope="scope">
              {{ (scope.row.GoodNums * scope.row.Price).toFixed(2) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-button type="text" class="delete-btn" @click="removeDetail(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top: 20px">
          <el-button type="primary" @click="addDetail">添加商品</el-button>
        </div>
        <div slot="footer">
          <el-button @click="detailsDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="confirmDetails">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 付款对话框 -->
      <el-dialog
        title="采购付款"
        :visible.sync="paymentDialogVisible"
        width="60%"
        append-to-body>
        <el-form ref="paymentForm" :model="paymentForm" :rules="paymentRules" label-width="100px">
          <el-form-item label="付款金额" prop="PaymentAmount">
            <el-input-number 
              v-model="paymentForm.PaymentAmount" 
              :precision="2" 
              :step="0.1"
              :max="currentSubOrder.Money - currentSubOrder.PayMoney"
              style="width: 200px">
            </el-input-number>
            <span style="margin-left: 10px">
              剩余应付：{{ (currentSubOrder.Money - currentSubOrder.PayMoney).toFixed(2) }}
            </span>
          </el-form-item>
          <el-form-item label="付款方式" prop="PaymentMethod">
            <el-select v-model="paymentForm.PaymentMethod" style="width: 200px">
              <el-option label="现金" :value="1"></el-option>
              <el-option label="银行转账" :value="2"></el-option>
              <el-option label="支票" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="付款账号" prop="PaymentAccount">
            <el-input v-model="paymentForm.PaymentAccount" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="付款凭证" prop="PaymentVoucher">
            <el-input v-model="paymentForm.PaymentVoucher" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="PaymentRemark">
            <el-input 
              type="textarea" 
              v-model="paymentForm.PaymentRemark"
              :rows="3"
              style="width: 400px">
            </el-input>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="paymentDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitPayment">确 定</el-button>
        </div>
      </el-dialog>
    </el-form>
    
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="submitForm">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'CreateOrder',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    planData: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      dialogVisible: false,
      detailsDialogVisible: false,
      paymentDialogVisible: false,
      currentEditIndex: -1,
      currentDetails: [],
      currentSubOrder: {},
      orderForm: {
        OrderName: '',
        PlanID: '',
        subOrders: []
      },
      rules: {
        OrderName: [
          { required: true, message: '请输入订单名称', trigger: 'blur' }
        ],
        PlanID: [
          { required: true, message: '请选择采购计划', trigger: 'change' }
        ]
      },
      planOptions: [],
      supplierOptions: [],
      goodsOptions: [],
      paymentForm: {
        PaymentAmount: 0,
        PaymentMethod: 1,
        PaymentAccount: '',
        PaymentVoucher: '',
        PaymentRemark: '',
        PaymentStatus: 1
      },
      paymentRules: {
        PaymentAmount: [
          { required: true, message: '请输入付款金额', trigger: 'blur' },
          { type: 'number', min: 0.01, message: '金额必须大于0', trigger: 'blur' }
        ],
        PaymentMethod: [
          { required: true, message: '请选择付款方式', trigger: 'change' }
        ],
        PaymentAccount: [
          { required: true, message: '请输入付款账号', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    visible: {
      handler(val) {
        this.dialogVisible = val
        if (val && this.planData) {
          this.initFromPlan()
        }
      },
      immediate: true
    }
  },
  methods: {
    // 添加子订单
    addSubOrder() {
      this.orderForm.subOrders.push({
        SupplierID: '',
        Logistics: '',
        details: [],
        Money: 0,
        PayMoney: 0,
        payments: []
      })
    },
    
    // 删除子订单
    removeSubOrder(index) {
      this.$confirm('确认删除该子订单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.orderForm.subOrders.splice(index, 1)
      })
    },
    
    // 编辑明细
    editDetails(index) {
      this.currentEditIndex = index
      this.currentDetails = JSON.parse(JSON.stringify(this.orderForm.subOrders[index].details || []))
      this.detailsDialogVisible = true
    },
    
    // 添加商品明细
    addDetail() {
      this.currentDetails.push({
        GoodId: '',
        GoodSpecs: '',
        GoodNums: 1,
        Price: 0,
        Money: 0
      })
    },
    
    // 删除商品明细
    removeDetail(index) {
      this.currentDetails.splice(index, 1)
    },
    
    // 确认商品明细
    confirmDetails() {
      this.$set(this.orderForm.subOrders[this.currentEditIndex], 'details', this.currentDetails)
      const total = this.currentDetails.reduce((sum, item) => {
        return sum + (item.GoodNums * item.Price)
      }, 0)
      this.$set(this.orderForm.subOrders[this.currentEditIndex], 'Money', total)
      this.detailsDialogVisible = false
    },
    
    // 提交表单
    submitForm() {
      this.$refs.orderForm.validate(valid => {
        if (valid) {
          // TODO: 调用创建订单API
          this.$emit('submit', this.orderForm)
          this.handleClose()
        }
      })
    },
    
    // 关闭对话框
    handleClose() {
      this.$confirm('确认关闭？未保存的数据将会丢失', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.resetForm()
        this.$emit('update:visible', false)
      })
    },
    
    // 重置表单
    resetForm() {
      this.orderForm = {
        OrderName: '',
        PlanID: '',
        subOrders: []
      }
      this.currentDetails = []
      this.currentSubOrder = {}
      if (this.$refs.orderForm) {
        this.$refs.orderForm.resetFields()
      }
    },
    
    // 获取初始数据
    async fetchInitialData() {
      // TODO: 获取采购计划、供应商、商品等选项数据
      this.planOptions = []
      this.supplierOptions = []
      this.goodsOptions = []
    },
    
    // 获取付款状态类型
    getPaymentStatusType(row) {
      const total = row.Money || 0
      const paid = row.PayMoney || 0
      if (paid === 0) return 'danger'
      if (paid >= total) return 'success'
      return 'warning'
    },
    
    // 获取付款状态文本
    getPaymentStatusText(row) {
      const total = row.Money || 0
      const paid = row.PayMoney || 0
      if (paid === 0) return '未付款'
      if (paid >= total) return '已付清'
      return '部分付款'
    },
    
    // 处理付款
    handlePayment(index) {
      this.currentEditIndex = index
      this.currentSubOrder = this.orderForm.subOrders[index]
      this.paymentForm = {
        PaymentAmount: 0,
        PaymentMethod: 1,
        PaymentAccount: '',
        PaymentVoucher: '',
        PaymentRemark: '',
        PaymentStatus: 1
      }
      this.paymentDialogVisible = true
    },
    
    // 提交付款
    submitPayment() {
      this.$refs.paymentForm.validate(valid => {
        if (valid) {
          const payment = {
            ...this.paymentForm,
            PaymentTime: new Date(),
            SubOrderID: this.currentSubOrder.SubOrderID
          }
          
          if (!this.currentSubOrder.payments) {
            this.$set(this.currentSubOrder, 'payments', [])
          }
          this.currentSubOrder.payments.push(payment)
          
          if (!this.currentSubOrder.PayMoney) {
            this.$set(this.currentSubOrder, 'PayMoney', 0)
          }
          this.currentSubOrder.PayMoney += this.paymentForm.PaymentAmount
          
          this.paymentDialogVisible = false
          this.$message.success('付款记录已添加')
        }
      })
    },
    
    // 从计划初始化订单
    initFromPlan() {
      if (!this.planData) return
      
      this.orderForm = {
        OrderName: `采购订单-${this.planData.PlanName || ''}`,
        PlanID: this.planData.PlanID,
        subOrders: []
      }
      
      // 如果计划中有明细，自动创建子订单
      if (this.planData.details && this.planData.details.length > 0) {
        // 按供应商分组创建子订单
        const supplierGroups = this.groupBySupplier(this.planData.details)
        
        Object.entries(supplierGroups).forEach(([supplierId, details]) => {
          this.orderForm.subOrders.push({
            SupplierID: supplierId,
            Logistics: '',
            details: details.map(item => ({
              GoodId: item.GoodId,
              GoodSpecs: item.GoodSpecs,
              GoodNums: item.PlanNums,
              Price: item.EstimatedPrice || 0,
              Money: (item.PlanNums * (item.EstimatedPrice || 0))
            })),
            Money: details.reduce((sum, item) => 
              sum + (item.PlanNums * (item.EstimatedPrice || 0)), 0),
            PayMoney: 0,
            payments: []
          })
        })
      }
    },
    
    // 按供应商分组计划明细
    groupBySupplier(details) {
      return details.reduce((groups, item) => {
        if (!groups[item.SupplierId]) {
          groups[item.SupplierId] = []
        }
        groups[item.SupplierId].push(item)
        return groups
      }, {})
    }
  },
  created() {
    this.fetchInitialData()
  }
}
</script>

<style lang="scss" scoped>
.box-card {
  margin-bottom: 20px;
}

.sub-order-card {
  margin-bottom: 20px;
  
  ::v-deep .el-table {
    // 表格整体样式
    margin-top: 10px;
    
    // 表头样式
    th {
      background-color: #f5f7fa !important;
      color: #606266;
      font-weight: 600;
      padding: 12px 0;
    }
    
    // 单元格样式
    td {
      padding: 8px 0;
    }
    
    // 金额文本样式
    .amount-text {
      font-family: Arial, sans-serif;
      font-weight: 500;
      color: #606266;
    }
    
    // 操作按钮容器样式
    .operation-buttons {
      display: flex;
      justify-content: space-around;
      align-items: center;
      white-space: nowrap;
      
      .el-button {
        flex: 1;
        padding: 0 8px;
        
        &.delete-btn {
          color: #F56C6C;
        }
        
        i {
          margin-right: 4px;
        }
      }
      
      .el-divider--vertical {
        height: 1em;
        margin: 0;
      }
    }
  }
}

// 下拉选择器样式
.el-select {
  width: 100%;
}

// 对话框样式
::v-deep .el-dialog__body {
  padding: 20px;
}

// 标签样式
.el-tag {
  font-weight: normal;
}
</style> 